<template>
  <div v-if="error" class="mx-4 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg shadow-sm">
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0">
        <v-icon color="error" size="24">mdi-alert-circle</v-icon>
      </div>
      
      <div class="flex-1 min-w-0">
        <h3 class="text-sm font-medium text-red-800">
          {{ $t('reports.error.title') }}
        </h3>
        <div class="mt-1 text-sm text-red-700">
          <p>{{ error }}</p>
        </div>
        
        <!-- Error Actions -->
        <div v-if="showActions" class="mt-3 flex gap-2">
          <button
            @click="handleRetry"
            class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-700 bg-red-100 border border-red-300 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            :disabled="isRetrying"
          >
            <v-icon v-if="isRetrying" size="small" class="animate-spin mr-1">mdi-loading</v-icon>
            <v-icon v-else size="small" class="mr-1">mdi-refresh</v-icon>
            {{ $t('reports.error.retry') }}
          </button>
          
          <button
            @click="handleDismiss"
            class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-red-700 bg-transparent border border-red-300 rounded-md hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <v-icon size="small" class="mr-1">mdi-close</v-icon>
            {{ $t('reports.error.dismiss') }}
          </button>
        </div>
      </div>
      
      <!-- Close Button -->
      <button
        @click="handleDismiss"
        class="flex-shrink-0 text-red-400 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 rounded-md"
        :aria-label="$t('reports.error.close')"
      >
        <v-icon size="small">mdi-close</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportError',
  props: {
    error: {
      type: String,
      default: null
    },
    showActions: {
      type: Boolean,
      default: true
    },
    isRetrying: {
      type: Boolean,
      default: false
    }
  },
  emits: ['retry', 'dismiss'],
  methods: {
    handleRetry() {
      this.$emit('retry');
    },
    handleDismiss() {
      this.$emit('dismiss');
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style> 